// Drives the UI instead of the endpoint now
export var PlanNames;
(function (PlanNames) {
    PlanNames["Mini"] = "Mini";
    PlanNames["Starter"] = "Starter";
    PlanNames["Professional"] = "Professional";
    PlanNames["Multi"] = "Multi";
    PlanNames["MultiPlus"] = "Multi+";
    PlanNames["Multi3000"] = "Multi 3000";
    // Grandfathered plans
    PlanNames["LegacyStarter"] = "Starter (Legacy)";
    PlanNames["LegacyUnlimited"] = "Unlimited (Legacy)";
    PlanNames["LegacyStandard"] = "Standard (Legacy)";
    PlanNames["LegacyPro"] = "Pro (Legacy)";
    PlanNames["LegacyLite"] = "Lite (Legacy)";
})(PlanNames || (PlanNames = {}));
//# sourceMappingURL=planNames.js.map